(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-infra-commons-commons-domain.js', './boislocal-platform-platform-s2-product-product-domain.js', './boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain.js', './boislocal-platform-platform-s2-removalZone-removalZone-domain.js', './boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'), require('./boislocal-platform-platform-s2-product-product-domain.js'), require('./boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain.js'), require('./boislocal-platform-platform-s2-removalZone-removalZone-domain.js'), require('./boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-product-product-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'. Its dependency 'boislocal-platform-platform-s2-product-product-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-product-product-domain' is loaded prior to 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'. Its dependency 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain' is loaded prior to 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-removalZone-removalZone-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'. Its dependency 'boislocal-platform-platform-s2-removalZone-removalZone-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-removalZone-removalZone-domain' is loaded prior to 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'. Its dependency 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain' is loaded prior to 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain'.");
    }
    root['boislocal-platform-platform-s2-ouvrage-ouvrage-domain'] = factory(typeof this['boislocal-platform-platform-s2-ouvrage-ouvrage-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-ouvrage-ouvrage-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-infra-commons-commons-domain'], this['boislocal-platform-platform-s2-product-product-domain'], this['boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'], this['boislocal-platform-platform-s2-removalZone-removalZone-domain'], this['boislocal-platform-platform-s2-referential-ouvrageType-ouvrageType-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_commons_domain, kotlin_org_boislocal_product_domain, kotlin_org_boislocal_woodSpecies_domain, kotlin_org_boislocal_removalZone_domain, kotlin_org_boislocal_ouvrageType_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var $serializer_init_$Create$ = kotlin_org_boislocal_commons_domain.$_$.a;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var $serializer_getInstance = kotlin_org_boislocal_commons_domain.$_$.e;
  var hashCode = kotlin_kotlin.$_$.j9;
  var equals = kotlin_kotlin.$_$.c9;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var $serializer_getInstance_0 = kotlin_org_boislocal_product_domain.$_$.b;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var $serializer_getInstance_1 = kotlin_org_boislocal_woodSpecies_domain.$_$.a;
  var $serializer_getInstance_2 = kotlin_org_boislocal_removalZone_domain.$_$.a;
  var $serializer_getInstance_3 = kotlin_org_boislocal_ouvrageType_domain.$_$.a;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var Long = kotlin_kotlin.$_$.ed;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(OuvrageState, 'OuvrageState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(OuvrageCreateCommandDTO, 'OuvrageCreateCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(OuvrageCreatedEventDTO, 'OuvrageCreatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(OuvrageDeleteCommandDTO, 'OuvrageDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(OuvrageDeletedEventDTO, 'OuvrageDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageDeleteCommand, 'OuvrageDeleteCommand', classMeta, VOID, [OuvrageDeleteCommandDTO], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(OuvrageFinishCommandDTO, 'OuvrageFinishCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(OuvrageFinishedEventDTO, 'OuvrageFinishedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageFinishCommand, 'OuvrageFinishCommand', classMeta, VOID, [OuvrageFinishCommandDTO], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(OuvrageImportCommandDTO, 'OuvrageImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(OuvrageImportedEventDTO, 'OuvrageImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(OuvrageUnlockCommandDTO, 'OuvrageUnlockCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(OuvrageUnlockedEventDTO, 'OuvrageUnlockedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageUnlockCommand, 'OuvrageUnlockCommand', classMeta, VOID, [OuvrageUnlockCommandDTO], VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(OuvrageUpdateCommandDTO, 'OuvrageUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(OuvrageUpdatedEventDTO, 'OuvrageUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageUpdateCommand, 'OuvrageUpdateCommand', classMeta, VOID, [OuvrageUpdateCommandDTO], VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(OuvrageModelDTO, 'OuvrageModelDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OuvrageModel, 'OuvrageModel', classMeta, VOID, [OuvrageModelDTO], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(OuvrageRefDTO, 'OuvrageRefDTO', interfaceMeta);
  setMetadataFor(OuvrageModelGetQueryDTO, 'OuvrageModelGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(OuvrageModelGetResultDTO, 'OuvrageModelGetResultDTO', interfaceMeta);
  setMetadataFor(OuvrageModelPageQueryFiltersDTO, 'OuvrageModelPageQueryFiltersDTO', interfaceMeta);
  setMetadataFor(OuvrageModelPageQueryDTO, 'OuvrageModelPageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(OuvrageModelPageResultDTO, 'OuvrageModelPageResultDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.y2w_1.f2();
  }
  function OuvrageState$Companion$_anonymous__apoz1h() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.ouvrage.domain.automate.OuvrageState', values());
  }
  var OuvrageState_Exists_instance;
  var OuvrageState_Deleted_instance;
  var OuvrageState_Finished_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.y2w_1 = lazy(tmp_0, OuvrageState$Companion$_anonymous__apoz1h);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    OuvrageState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [OuvrageState_Exists_getInstance(), OuvrageState_Deleted_getInstance(), OuvrageState_Finished_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return OuvrageState_Exists_getInstance();
      case 'Deleted':
        return OuvrageState_Deleted_getInstance();
      case 'Finished':
        return OuvrageState_Finished_getInstance();
      default:
        OuvrageState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OuvrageState_entriesInitialized;
  function OuvrageState_initEntries() {
    if (OuvrageState_entriesInitialized)
      return Unit_instance;
    OuvrageState_entriesInitialized = true;
    OuvrageState_Exists_instance = new OuvrageState('Exists', 0, 0);
    OuvrageState_Deleted_instance = new OuvrageState('Deleted', 1, 1);
    OuvrageState_Finished_instance = new OuvrageState('Finished', 2, 2);
    Companion_getInstance();
  }
  function OuvrageState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.b2x_1 = position;
  }
  protoOf(OuvrageState).y2c = function (_set____db54di) {
    this.b2x_1 = _set____db54di;
  };
  protoOf(OuvrageState).jr = function () {
    return this.b2x_1;
  };
  function OuvrageState_Exists_getInstance() {
    OuvrageState_initEntries();
    return OuvrageState_Exists_instance;
  }
  function OuvrageState_Deleted_getInstance() {
    OuvrageState_initEntries();
    return OuvrageState_Deleted_instance;
  }
  function OuvrageState_Finished_getInstance() {
    OuvrageState_initEntries();
    return OuvrageState_Finished_instance;
  }
  function OuvrageCreateCommandDTO() {
  }
  function OuvrageCreatedEventDTO() {
  }
  function OuvrageDeleteCommandDTO() {
  }
  function OuvrageDeletedEventDTO() {
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrage.domain.command.OuvrageDeleteCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.e2x_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.e2x_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.e2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return OuvrageDeleteCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).f2x = function (encoder, value) {
    var tmp0_desc = this.e2x_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.g2x_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.f2x(encoder, value instanceof OuvrageDeleteCommand ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_4() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function OuvrageDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_4().e2x_1);
    }
    $this.g2x_1 = id;
    return $this;
  }
  function OuvrageDeleteCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return OuvrageDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(OuvrageDeleteCommand)));
  }
  function OuvrageDeleteCommand(id) {
    this.g2x_1 = id;
  }
  protoOf(OuvrageDeleteCommand).k1y = function () {
    return this.g2x_1;
  };
  protoOf(OuvrageDeleteCommand).toString = function () {
    return 'OuvrageDeleteCommand(id=' + this.g2x_1 + ')';
  };
  protoOf(OuvrageDeleteCommand).hashCode = function () {
    return getStringHashCode(this.g2x_1);
  };
  protoOf(OuvrageDeleteCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageDeleteCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageDeleteCommand ? other : THROW_CCE();
    if (!(this.g2x_1 === tmp0_other_with_cast.g2x_1))
      return false;
    return true;
  };
  function OuvrageFinishCommandDTO() {
  }
  function OuvrageFinishedEventDTO() {
  }
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrage.domain.command.OuvrageFinishCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.h2x_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.h2x_1;
  };
  protoOf($serializer_0).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.h2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return OuvrageFinishCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_0).i2x = function (encoder, value) {
    var tmp0_desc = this.h2x_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.j2x_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.i2x(encoder, value instanceof OuvrageFinishCommand ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_5() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function OuvrageFinishCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_5().h2x_1);
    }
    $this.j2x_1 = id;
    return $this;
  }
  function OuvrageFinishCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return OuvrageFinishCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(OuvrageFinishCommand)));
  }
  function OuvrageFinishCommand(id) {
    this.j2x_1 = id;
  }
  protoOf(OuvrageFinishCommand).k1y = function () {
    return this.j2x_1;
  };
  protoOf(OuvrageFinishCommand).toString = function () {
    return 'OuvrageFinishCommand(id=' + this.j2x_1 + ')';
  };
  protoOf(OuvrageFinishCommand).hashCode = function () {
    return getStringHashCode(this.j2x_1);
  };
  protoOf(OuvrageFinishCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageFinishCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageFinishCommand ? other : THROW_CCE();
    if (!(this.j2x_1 === tmp0_other_with_cast.j2x_1))
      return false;
    return true;
  };
  function OuvrageImportCommandDTO() {
  }
  function OuvrageImportedEventDTO() {
  }
  function OuvrageUnlockCommandDTO() {
  }
  function OuvrageUnlockedEventDTO() {
  }
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrage.domain.command.OuvrageUnlockCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.k2x_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.k2x_1;
  };
  protoOf($serializer_1).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.k2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return OuvrageUnlockCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).l2x = function (encoder, value) {
    var tmp0_desc = this.k2x_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.m2x_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.l2x(encoder, value instanceof OuvrageUnlockCommand ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_6() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function OuvrageUnlockCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_6().k2x_1);
    }
    $this.m2x_1 = id;
    return $this;
  }
  function OuvrageUnlockCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return OuvrageUnlockCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(OuvrageUnlockCommand)));
  }
  function OuvrageUnlockCommand(id) {
    this.m2x_1 = id;
  }
  protoOf(OuvrageUnlockCommand).k1y = function () {
    return this.m2x_1;
  };
  protoOf(OuvrageUnlockCommand).toString = function () {
    return 'OuvrageUnlockCommand(id=' + this.m2x_1 + ')';
  };
  protoOf(OuvrageUnlockCommand).hashCode = function () {
    return getStringHashCode(this.m2x_1);
  };
  protoOf(OuvrageUnlockCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageUnlockCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageUnlockCommand ? other : THROW_CCE();
    if (!(this.m2x_1 === tmp0_other_with_cast.m2x_1))
      return false;
    return true;
  };
  function OuvrageUpdateCommandDTO() {
  }
  function OuvrageUpdatedEventDTO() {
  }
  function Companion_3() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q2x_1 = [null, null, null, null, $serializer_init_$Create$(StringSerializer_getInstance())];
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrage.domain.command.OuvrageUpdateCommand', this, 5);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('description', false);
    tmp0_serialDesc.ht('imageCommand', false);
    tmp0_serialDesc.ht('realization', false);
    this.r2x_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.r2x_1;
  };
  protoOf($serializer_2).wt = function () {
    var tmp0_cached = Companion_getInstance_3().q2x_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance()), get_nullable(tmp0_cached[4])];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.r2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.ul(tmp0_desc);
    var tmp10_cached = Companion_getInstance_3().q2x_1;
    if (tmp9_input.km()) {
      tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.im(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.im(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.vl(tmp0_desc);
    return OuvrageUpdateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_2).s2x = function (encoder, value) {
    var tmp0_desc = this.r2x_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_3().q2x_1;
    tmp1_output.jn(tmp0_desc, 0, value.t2x_1);
    tmp1_output.jn(tmp0_desc, 1, value.u2x_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.v2x_1);
    tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance(), value.w2x_1);
    tmp1_output.nn(tmp0_desc, 4, tmp2_cached[4], value.x2x_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.s2x(encoder, value instanceof OuvrageUpdateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_7() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function OuvrageUpdateCommand_init_$Init$(seen1, id, name, description, imageCommand, realization, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_7().r2x_1);
    }
    $this.t2x_1 = id;
    $this.u2x_1 = name;
    $this.v2x_1 = description;
    $this.w2x_1 = imageCommand;
    $this.x2x_1 = realization;
    return $this;
  }
  function OuvrageUpdateCommand_init_$Create$(seen1, id, name, description, imageCommand, realization, serializationConstructorMarker) {
    return OuvrageUpdateCommand_init_$Init$(seen1, id, name, description, imageCommand, realization, serializationConstructorMarker, objectCreate(protoOf(OuvrageUpdateCommand)));
  }
  function OuvrageUpdateCommand(id, name, description, imageCommand, realization) {
    Companion_getInstance_3();
    this.t2x_1 = id;
    this.u2x_1 = name;
    this.v2x_1 = description;
    this.w2x_1 = imageCommand;
    this.x2x_1 = realization;
  }
  protoOf(OuvrageUpdateCommand).k1y = function () {
    return this.t2x_1;
  };
  protoOf(OuvrageUpdateCommand).h9 = function () {
    return this.u2x_1;
  };
  protoOf(OuvrageUpdateCommand).w25 = function () {
    return this.v2x_1;
  };
  protoOf(OuvrageUpdateCommand).n2x = function () {
    return this.w2x_1;
  };
  protoOf(OuvrageUpdateCommand).o2x = function () {
    return this.x2x_1;
  };
  protoOf(OuvrageUpdateCommand).toString = function () {
    return 'OuvrageUpdateCommand(id=' + this.t2x_1 + ', name=' + this.u2x_1 + ', description=' + this.v2x_1 + ', imageCommand=' + this.w2x_1 + ', realization=' + this.x2x_1 + ')';
  };
  protoOf(OuvrageUpdateCommand).hashCode = function () {
    var result = getStringHashCode(this.t2x_1);
    result = imul(result, 31) + getStringHashCode(this.u2x_1) | 0;
    result = imul(result, 31) + (this.v2x_1 == null ? 0 : getStringHashCode(this.v2x_1)) | 0;
    result = imul(result, 31) + (this.w2x_1 == null ? 0 : this.w2x_1.hashCode()) | 0;
    result = imul(result, 31) + (this.x2x_1 == null ? 0 : hashCode(this.x2x_1)) | 0;
    return result;
  };
  protoOf(OuvrageUpdateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageUpdateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageUpdateCommand ? other : THROW_CCE();
    if (!(this.t2x_1 === tmp0_other_with_cast.t2x_1))
      return false;
    if (!(this.u2x_1 === tmp0_other_with_cast.u2x_1))
      return false;
    if (!(this.v2x_1 == tmp0_other_with_cast.v2x_1))
      return false;
    if (!equals(this.w2x_1, tmp0_other_with_cast.w2x_1))
      return false;
    if (!equals(this.x2x_1, tmp0_other_with_cast.x2x_1))
      return false;
    return true;
  };
  function OuvrageModelDTO() {
  }
  function Companion_4() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a2y_1 = [null, $serializer_init_$Create$(StringSerializer_getInstance()), Companion_getInstance().x14(), null, null, null, null, new ArrayListSerializer($serializer_getInstance_0()), new ArrayListSerializer($serializer_getInstance_1()), new ArrayListSerializer($serializer_getInstance_2()), null];
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.ouvrage.domain.model.OuvrageModel', this, 11);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('realisation', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('description', false);
    tmp0_serialDesc.ht('ouvrageType', false);
    tmp0_serialDesc.ht('cover', false);
    tmp0_serialDesc.ht('composedBy', false);
    tmp0_serialDesc.ht('species', false);
    tmp0_serialDesc.ht('removalZones', false);
    tmp0_serialDesc.ht('creationDate', false);
    this.b2y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.b2y_1;
  };
  protoOf($serializer_3).wt = function () {
    var tmp0_cached = Companion_getInstance_4().a2y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(tmp0_cached[1]), tmp0_cached[2], StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_3()), get_nullable(StringSerializer_getInstance()), tmp0_cached[7], tmp0_cached[8], tmp0_cached[9], LongSerializer_getInstance()];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.b2y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = new Long(0, 0);
    var tmp15_input = decoder.ul(tmp0_desc);
    var tmp16_cached = Companion_getInstance_4().a2y_1;
    if (tmp15_input.km()) {
      tmp4_local0 = tmp15_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.im(tmp0_desc, 1, tmp16_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.gm(tmp0_desc, 2, tmp16_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.em(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.im(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.im(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.gm(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.gm(tmp0_desc, 8, tmp16_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.gm(tmp0_desc, 9, tmp16_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.am(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.im(tmp0_desc, 1, tmp16_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.gm(tmp0_desc, 2, tmp16_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.em(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.im(tmp0_desc, 5, $serializer_getInstance_3(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.im(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.gm(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.gm(tmp0_desc, 8, tmp16_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.gm(tmp0_desc, 9, tmp16_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.am(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.vl(tmp0_desc);
    return OuvrageModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_3).c2y = function (encoder, value) {
    var tmp0_desc = this.b2y_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_4().a2y_1;
    tmp1_output.jn(tmp0_desc, 0, value.d2y_1);
    tmp1_output.nn(tmp0_desc, 1, tmp2_cached[1], value.e2y_1);
    tmp1_output.ln(tmp0_desc, 2, tmp2_cached[2], value.f2y_1);
    tmp1_output.jn(tmp0_desc, 3, value.g2y_1);
    tmp1_output.nn(tmp0_desc, 4, StringSerializer_getInstance(), value.h2y_1);
    tmp1_output.nn(tmp0_desc, 5, $serializer_getInstance_3(), value.i2y_1);
    tmp1_output.nn(tmp0_desc, 6, StringSerializer_getInstance(), value.j2y_1);
    tmp1_output.ln(tmp0_desc, 7, tmp2_cached[7], value.k2y_1);
    tmp1_output.ln(tmp0_desc, 8, tmp2_cached[8], value.l2y_1);
    tmp1_output.ln(tmp0_desc, 9, tmp2_cached[9], value.m2y_1);
    tmp1_output.fn(tmp0_desc, 10, value.n2y_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.c2y(encoder, value instanceof OuvrageModel ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_8() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function OuvrageModel_init_$Init$(seen1, id, realisation, status, name, description, ouvrageType, cover, composedBy, species, removalZones, creationDate, serializationConstructorMarker, $this) {
    if (!(2047 === (2047 & seen1))) {
      throwMissingFieldException(seen1, 2047, $serializer_getInstance_8().b2y_1);
    }
    $this.d2y_1 = id;
    $this.e2y_1 = realisation;
    $this.f2y_1 = status;
    $this.g2y_1 = name;
    $this.h2y_1 = description;
    $this.i2y_1 = ouvrageType;
    $this.j2y_1 = cover;
    $this.k2y_1 = composedBy;
    $this.l2y_1 = species;
    $this.m2y_1 = removalZones;
    $this.n2y_1 = creationDate;
    return $this;
  }
  function OuvrageModel_init_$Create$(seen1, id, realisation, status, name, description, ouvrageType, cover, composedBy, species, removalZones, creationDate, serializationConstructorMarker) {
    return OuvrageModel_init_$Init$(seen1, id, realisation, status, name, description, ouvrageType, cover, composedBy, species, removalZones, creationDate, serializationConstructorMarker, objectCreate(protoOf(OuvrageModel)));
  }
  function OuvrageModel() {
  }
  protoOf(OuvrageModel).k1y = function () {
    return this.d2y_1;
  };
  protoOf(OuvrageModel).c2x = function () {
    return this.e2y_1;
  };
  protoOf(OuvrageModel).y2f = function () {
    return this.f2y_1;
  };
  protoOf(OuvrageModel).h9 = function () {
    return this.g2y_1;
  };
  protoOf(OuvrageModel).w25 = function () {
    return this.h2y_1;
  };
  protoOf(OuvrageModel).d2x = function () {
    return this.i2y_1;
  };
  protoOf(OuvrageModel).p2x = function () {
    return this.j2y_1;
  };
  protoOf(OuvrageModel).y2x = function () {
    return this.k2y_1;
  };
  protoOf(OuvrageModel).s2v = function () {
    return this.l2y_1;
  };
  protoOf(OuvrageModel).z2x = function () {
    return this.m2y_1;
  };
  protoOf(OuvrageModel).v2h = function () {
    return this.n2y_1;
  };
  protoOf(OuvrageModel).s2State = function () {
    return this.f2y_1;
  };
  protoOf(OuvrageModel).s2Id = function () {
    return this.d2y_1;
  };
  protoOf(OuvrageModel).toString = function () {
    return 'OuvrageModel(id=' + this.d2y_1 + ', realisation=' + this.e2y_1 + ', status=' + this.f2y_1 + ', name=' + this.g2y_1 + ', description=' + this.h2y_1 + ', ouvrageType=' + this.i2y_1 + ', cover=' + this.j2y_1 + ', composedBy=' + this.k2y_1 + ', species=' + this.l2y_1 + ', removalZones=' + this.m2y_1 + ', creationDate=' + this.n2y_1.toString() + ')';
  };
  protoOf(OuvrageModel).hashCode = function () {
    var result = getStringHashCode(this.d2y_1);
    result = imul(result, 31) + (this.e2y_1 == null ? 0 : hashCode(this.e2y_1)) | 0;
    result = imul(result, 31) + this.f2y_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.g2y_1) | 0;
    result = imul(result, 31) + (this.h2y_1 == null ? 0 : getStringHashCode(this.h2y_1)) | 0;
    result = imul(result, 31) + (this.i2y_1 == null ? 0 : this.i2y_1.hashCode()) | 0;
    result = imul(result, 31) + (this.j2y_1 == null ? 0 : getStringHashCode(this.j2y_1)) | 0;
    result = imul(result, 31) + hashCode(this.k2y_1) | 0;
    result = imul(result, 31) + hashCode(this.l2y_1) | 0;
    result = imul(result, 31) + hashCode(this.m2y_1) | 0;
    result = imul(result, 31) + this.n2y_1.hashCode() | 0;
    return result;
  };
  protoOf(OuvrageModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OuvrageModel))
      return false;
    var tmp0_other_with_cast = other instanceof OuvrageModel ? other : THROW_CCE();
    if (!(this.d2y_1 === tmp0_other_with_cast.d2y_1))
      return false;
    if (!equals(this.e2y_1, tmp0_other_with_cast.e2y_1))
      return false;
    if (!this.f2y_1.equals(tmp0_other_with_cast.f2y_1))
      return false;
    if (!(this.g2y_1 === tmp0_other_with_cast.g2y_1))
      return false;
    if (!(this.h2y_1 == tmp0_other_with_cast.h2y_1))
      return false;
    if (!equals(this.i2y_1, tmp0_other_with_cast.i2y_1))
      return false;
    if (!(this.j2y_1 == tmp0_other_with_cast.j2y_1))
      return false;
    if (!equals(this.k2y_1, tmp0_other_with_cast.k2y_1))
      return false;
    if (!equals(this.l2y_1, tmp0_other_with_cast.l2y_1))
      return false;
    if (!equals(this.m2y_1, tmp0_other_with_cast.m2y_1))
      return false;
    if (!this.n2y_1.equals(tmp0_other_with_cast.n2y_1))
      return false;
    return true;
  };
  function OuvrageRefDTO() {
  }
  function OuvrageModelGetQueryDTO() {
  }
  function OuvrageModelGetResultDTO() {
  }
  function OuvrageModelPageQueryFiltersDTO() {
  }
  function OuvrageModelPageQueryDTO() {
  }
  function OuvrageModelPageResultDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(OuvrageState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(OuvrageState), 'name', protoOf(OuvrageState).h9);
  defineProp(protoOf(OuvrageState), 'ordinal', protoOf(OuvrageState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageDeleteCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageFinishCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageUnlockCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageUpdateCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OuvrageUpdateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(OuvrageUpdateCommand), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(OuvrageUpdateCommand), 'imageCommand', function () {
    return this.n2x();
  });
  defineProp(protoOf(OuvrageUpdateCommand), 'realization', function () {
    return this.o2x();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(OuvrageModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OuvrageModel), 'realisation', function () {
    return this.c2x();
  });
  defineProp(protoOf(OuvrageModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(OuvrageModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(OuvrageModel), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(OuvrageModel), 'ouvrageType', function () {
    return this.d2x();
  });
  defineProp(protoOf(OuvrageModel), 'cover', function () {
    return this.p2x();
  });
  defineProp(protoOf(OuvrageModel), 'composedBy', function () {
    return this.y2x();
  });
  defineProp(protoOf(OuvrageModel), 'species', function () {
    return this.s2v();
  });
  defineProp(protoOf(OuvrageModel), 'removalZones', function () {
    return this.z2x();
  });
  defineProp(protoOf(OuvrageModel), 'creationDate', function () {
    return this.v2h();
  });
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$automate = $org$boislocal$platform$s2$ouvrage$domain.automate || ($org$boislocal$platform$s2$ouvrage$domain.automate = {});
    $org$boislocal$platform$s2$ouvrage$domain$automate.OuvrageState = OuvrageState;
    $org$boislocal$platform$s2$ouvrage$domain$automate.OuvrageState.values = values;
    $org$boislocal$platform$s2$ouvrage$domain$automate.OuvrageState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$ouvrage$domain$automate.OuvrageState, 'Exists', OuvrageState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$ouvrage$domain$automate.OuvrageState, 'Deleted', OuvrageState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$ouvrage$domain$automate.OuvrageState, 'Finished', OuvrageState_Finished_getInstance);
    defineProp($org$boislocal$platform$s2$ouvrage$domain$automate.OuvrageState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$command = $org$boislocal$platform$s2$ouvrage$domain.command || ($org$boislocal$platform$s2$ouvrage$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$command = $org$boislocal$platform$s2$ouvrage$domain.command || ($org$boislocal$platform$s2$ouvrage$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$command = $org$boislocal$platform$s2$ouvrage$domain.command || ($org$boislocal$platform$s2$ouvrage$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$command = $org$boislocal$platform$s2$ouvrage$domain.command || ($org$boislocal$platform$s2$ouvrage$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$command = $org$boislocal$platform$s2$ouvrage$domain.command || ($org$boislocal$platform$s2$ouvrage$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$command = $org$boislocal$platform$s2$ouvrage$domain.command || ($org$boislocal$platform$s2$ouvrage$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$model = $org$boislocal$platform$s2$ouvrage$domain.model || ($org$boislocal$platform$s2$ouvrage$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$model = $org$boislocal$platform$s2$ouvrage$domain.model || ($org$boislocal$platform$s2$ouvrage$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$query = $org$boislocal$platform$s2$ouvrage$domain.query || ($org$boislocal$platform$s2$ouvrage$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$ouvrage = $org$boislocal$platform$s2.ouvrage || ($org$boislocal$platform$s2.ouvrage = {});
    var $org$boislocal$platform$s2$ouvrage$domain = $org$boislocal$platform$s2$ouvrage.domain || ($org$boislocal$platform$s2$ouvrage.domain = {});
    var $org$boislocal$platform$s2$ouvrage$domain$query = $org$boislocal$platform$s2$ouvrage$domain.query || ($org$boislocal$platform$s2$ouvrage$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = $serializer_getInstance_8;
  _.$_$.b = OuvrageDeleteCommand;
  _.$_$.c = OuvrageFinishCommand;
  _.$_$.d = OuvrageUnlockCommand;
  _.$_$.e = OuvrageUpdateCommand;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-ouvrage-ouvrage-domain.js.map
